import { FormGroup, InputLabel, TextField, Typography } from "@mui/material";
import ErrorMessageTypo from "./ErrorMessageTypo";
import Label from "./Label";

export const BasicFormikTextField = ({
  field,
  fieldId,
  formik,
  placeholder,
  helperText,
  labelAlignement = null,
  disabled = false,
}) => {
  const label = field.spec.label;
  field.spec.label = label;
  const key = fieldId;

  return (
    <>
      {labelAlignement && <Label label={label} />}
      <FormGroup
        key={key}
        sx={{
          marginTop: 1,
        }}
      >
        {!labelAlignement && <InputLabel htmlFor={fieldId}>{label}</InputLabel>}
        {helperText && (
          <>
            <Typography
              variant=""
              sx={{
                color: "text.secondary",
                fontSize: "0.65rem",
                fontWeight: "bold",
                fontStyle: "italic",
              }}
            >
              {helperText}
            </Typography>
          </>
        )}
        <TextField
          type="text"
          name={key}
          id={key}
          size="small"
          placeholder={placeholder}
          value={formik.values[key]}
          onChange={formik.handleChange}
          error={formik.errors[key] ? true : false}
          disabled={disabled}
        />
        {formik.errors[key] ? (
          <ErrorMessageTypo error={formik.errors[key]} />
        ) : null}
      </FormGroup>
    </>
  );
};

export default BasicFormikTextField;
